import styled from '@emotion/styled'
import { css, SerializedStyles } from '@emotion/react'
import React, { Component } from 'react'
import { Modifiable, Mods } from '../../../styles/primitives/core/mods'
import { ensureArray } from '../../../../lib/types/arrays'
import { PaddingMods } from '../../../styles/primitives/modifiers/shape/padding'

/**
 * Imposter stub
 * https://every-layout.dev/layouts/imposter/
 */
const ImposterBase = styled.div<Mods>`
	position: absolute;
	//max-width: 100%;
	//max-height: 100%;
	${PaddingMods.Base}
	${Modifiable};
`

type Layouts = 'filled' | 'centered'

const LayoutStyles: Record<Layouts, SerializedStyles> = {
	filled: css`
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
	`,
	centered: css`
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
	`
}

interface ImposterProps extends Mods {
	format: Layouts
	visible?: boolean
	Container?: Component
}

export const Imposter: React.FC<React.PropsWithChildren<ImposterProps>> = ({
	children,
	format = 'centered',
	modifiers,
	visible = true
}) => (
	<ImposterBase modifiers={[LayoutStyles[format], ...ensureArray(modifiers), visibility(visible)]}>
		{children}
	</ImposterBase>
)

export const ImposterContainer = css({ position: 'relative' })
const visibility = (visible = true) => css({ display: visible ? 'block' : 'none' })
